module.exports = __webpack_public_path__ + "img/metal-manufacturing.c85ce4e4.png";